import React, { FC } from 'react';

import { useHistory, useParams } from 'react-router';
import styled from 'styled-components';
import { Title } from '~/components';
import paths from '~/pages/paths';
import { ConfirmButton } from '~/layouts/ksa/CompanyInfoLayout';
import { errors } from './errors';

const ErrorPage: React.FC = () => {
  return <ErrorPageTemplate homeLink={paths.ksa.dataValidation._} />;
};

interface Props {
  homeLink: string;
}

export const ErrorPageTemplate: FC<Props> = ({ homeLink }) => {
  const history = useHistory();
  const params = useParams<{ errorType: string }>();
  const error = errors[params.errorType] || errors.default;

  const onClick = () => {
    const onClickLink = error.button?.onClickLink;
    if (onClickLink === 'HOME') {
      history.push(homeLink);
    } else if (onClickLink === 'BACK') {
      history.goBack();
    }
  };

  return (
    <>
      <Box>
        <BoxTitle>
          <Title text={error.title} />
        </BoxTitle>
        <div>
          {error.description.map((item, key) => (
            // its ok to use index as key here because the array is static
            // eslint-disable-next-line react/no-array-index-key
            <P key={key}>{item}</P>
          ))}
        </div>

        <ConfirmButton id="tryAgainButton" type="primary" htmlType="submit" onClick={onClick}>
          {error.button?.text}
        </ConfirmButton>
      </Box>
    </>
  );
};

const P = styled.p`
  margin-bottom: 32px;
  font-size: 18px;
`;

const BoxTitle = styled.div`
  margin-bottom: 60px;
`;

const Box = styled.div`
  height: 65vh;
`;

export default ErrorPage;
